import { Component, inject, Input } from '@angular/core';
import { PurchaseRequisitionPreview } from '../../types/IPurchaseRequisitionPreview';
import { IPurchaseRequisitionResultDocument } from '../../types/IPurchaseRequisitionResultDocument';
import { Router } from '@angular/router';

@Component({
    selector: 'purchase-requisition-item-preview',
    templateUrl: './purchase-requisition-preview.component.html',
    styleUrls: ['./purchase-requisition-preview.component.scss'],
    standalone: false
})
export class PurchaseRequisitionPreviewComponent {
    @Input({ required: true }) public preview!: PurchaseRequisitionPreview;
    @Input({ required: true }) public rfqLinkAllowed!: boolean;
    @Input({ required: true }) public orderLinkAllowed!: boolean;

    public showExtended = false;
    private readonly router: Router = inject(Router);

    navigateToResult(result: IPurchaseRequisitionResultDocument) {
        result.navigate(this.router);
    }
}
